export default "__VITE_ASSET__DwUarZ$B__"